(() => {
  const MODAL_SEL = '.jdgm-review-widget-modal';
  const OVERLAY_SEL = '.jdgm-write-review-modal__overlay';
  const CLOSE_SEL = '.jdgm-write-review-modal__close-btn';

  const attachOverlay = (modal) => {
    const overlay = modal.querySelector(OVERLAY_SEL);
    if (overlay && !overlay.dataset.jmBound) {
      overlay.dataset.jmBound = '1';
      overlay.addEventListener('click', () => {
        const closeBtn = modal.querySelector(CLOSE_SEL);
        if (closeBtn) closeBtn.click();
      });
    }
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          const modal = node.matches && node.matches(MODAL_SEL) ? node : node.querySelector && node.querySelector(MODAL_SEL);
          if (modal) attachOverlay(modal);
        }
      }

      if (mutation.type === 'attributes') {
        const target = mutation.target;
        if (!target.matches || !target.matches(MODAL_SEL)) continue;
        if (target.style.display === 'block') {
          document.body.style.overflow = 'hidden';
          attachOverlay(target);
        } else {
          document.body.style.overflow = '';
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = document.querySelector(MODAL_SEL);
    if (!modal || modal.style.display !== 'block') return;
    const closeBtn = modal.querySelector(CLOSE_SEL);
    if (closeBtn) closeBtn.click();
  });

  const existing = document.querySelector(MODAL_SEL);
  if (existing) {
    attachOverlay(existing);
    if (existing.style.display === 'block') document.body.style.overflow = 'hidden';
  }
})();
